import React from "react";
import styles from "../style.module.css"

export default function TeacherTitle() {
  return (
    <div className={`${styles["row"]} ${styles.rowBox}`}>
      <div className={styles["text_row"]}>Teacher Name</div>
      <div className={styles["text_row"]}>Teacher email ID</div>
      <div className={styles["text_row"]}>Role</div>
      <div className={styles["text_row"]}>Classes</div>
      <div className={styles["text_row"]}>Students</div>
      <div className={styles["text_row"]}>Action</div>
      {/* <div className={styles["text_row"]}></div> */}
    </div>
  );
}
